export default "__VITE_ASSET__BrtNrLrH__"